export default __webpack_public_path__ + "static/media/GoodEnuff.0e5882bb.png";